import { CART_MODULE } from "@/api_framework/api_config";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

interface IAPIreturnProps {
  status: boolean;
  data: any;
}

AxiosCurlirize(axios, () => {});

export const useMirrorMembershipSimulationAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async (cart_id: string, membership_id: string): Promise<IAPIreturnProps> => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      return await axios
        .post(
          `${CART_MODULE?.MIRROR_MEMBERSHIP_SIMULATION?.baseURL}`,
          { cart_id, membership_id },
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        )
        .then((res: AxiosResponse<any>) => {
          if (res.data) {
            return { status: true, data: res.data?.data ?? res.data };
          }
          return { status: false, data: null };
        })
        .catch((e: AxiosError) => {
          captureError(e);
          sendCurl(e.config?.["curlCommand"]);
          return { status: false, data: null };
        });
    } catch (e: any) {
      toast.error(e.message);
      return { status: false, data: null };
    }
  }, []);

  return execute;
};
